import { useEffect, useState } from "react";
import WorkListTable from "./WorkListTable";
import WatchListBodyAddVol from "./WatchListBodyAddVol";
import WatchListBodyAddFilter from "./WatchListBodyAddFilter.jsx";
import { getMasterData } from "../../../services/chartService";
import Select from "react-select";
const WorkListBody = ({ onQuery }) => {
  const [masterData, setMasterData] = useState();
  const [parentWorkList, setParentWorkList] = useState(false);
  const [filterList, setFilterList] = useState({});
  const [worklistCount, setWorklistCount] = useState(0);
  const [filterPagination, setFilterPagination] = useState(false);
  const [dataPerPage, setDataPerPage] = useState(10);

  useEffect(() => {
    fetchChartData();
  }, []);

  const fetchChartData = async () => {
    getMasterData()
      .then((response) => {
        setMasterData(response?.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleFilterList = (obj) => {
    setFilterList(obj);
  };

  const handlePageSizeUpdate = (e) => {
    setDataPerPage(e.value);
    console.log("Page Size " + dataPerPage);
  };

  const pageSizeOptions = [
    { value: "10", label: "10" },
    { value: "25", label: "25" },
    { value: "50", label: "50" },
    { value: "75", label: "75" },
    { value: "100", label: "100" },
  ];

  return (
    <div className="card">
      <div className="card-header border-0 pt-6">
        <h3 className="card-title align-items-start flex-column">
          <span className="card-label fw-bold text-gray-800">
            Worklist ({worklistCount})
          </span>
        </h3>
        <div className="card-toolbar justify-content-end">
          <div>
            <Select
              options={pageSizeOptions}
              value={pageSizeOptions.find(
                (option) => option.value === dataPerPage,
              )}
              onChange={handlePageSizeUpdate}
              placeholder="Page Size"
              styles={{
                control: (provided) => ({
                  ...provided,
                  height: "40px",
                  width: "140px",
                  justifyContent: "flex-end",
                  marginRight: "15px",
                }),
              }}
            />
          </div>
          <WatchListBodyAddFilter
            setFilterPagination={setFilterPagination}
            masterData={masterData}
            handleFilterList={handleFilterList}
            filterList={filterList}
          />
          {localStorage.getItem("Role") === "Manager" ||
          localStorage.getItem("Role") === "Team Lead" ? (
            <WatchListBodyAddVol
              changeParentList={setParentWorkList}
              masterData={masterData}
              onQuery={onQuery}
            />
          ) : (
            ""
          )}
        </div>
      </div>
      <WorkListTable
        setFilterPagination={setFilterPagination}
        parentWorkList={parentWorkList}
        changeParentList={setParentWorkList}
        filterList={filterList}
        setWorklistCount={setWorklistCount}
        filterPagination={filterPagination}
        dataPerPage={dataPerPage}
      />
    </div>
  );
};
export default WorkListBody;
